<template>
    <div id="app">
        <!--<transition name="fade" mode="out-in">-->
        <transition name="fade">
            <!--IMAGE PAGE-->
            <div v-if="this.page === 0" key="image_page">
                <div class="tabletBody">
                    <div class="container">
                        <div class="row">
                            <div class="presentation">
                                <img src="/presentations/1.jpg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- WORKER PAGE -->
            <div v-if="this.page === 1" key="worker_page">
                <div class="tabletBody">
                    <div class="container">
                        <div class="row">
                            <div class="worker_wrap">
                                <div class="header_line">
                                    ҚЫЗМЕТ КӨРСЕТУ АҒА КЕҢЕСШІСІ<br>
                                    КОНСУЛЬТАНТ ПО СЕРВИСУ
                                </div>

                                <div class="worker_name">
                                    {{ user_surname }}<br>
                                    {{ user_name }}
                                </div>
                                <div class="company_address">
                                    <strong>Тойота Центр Костанай</strong><br>
                                    ТОО «Тобол Моторс»<br>
                                    110000, г.Костанай, пр.Абая 26«в»<br>
                                    (7142) 26 81 81<br>
                                    (7142) 39 44 44<br>
                                    www.toyota-kostanay.kz
                                </div>
                            </div>
                            <div class="worker_photo">
                                <img :src="user_photo" :alt="user_surname">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--RATING PAGE-->
            <div v-if="this.page === 2" key="rating_page">
                <div class="tabletBody rating_page">
                    <div class="container">
                        <div class="row">
                            <div class="align-content-around d-flex flex-wrap justify-content-center rating_wrap">
                                <div class="rating_header text-center w-100">
                                    <div class="kaz">ҚЫЗМЕТ КӨРСЕТУ САПАСЫН</div>
                                    <div class="rus">ОЦЕНИТЕ КАЧЕСТВО ОБСЛУЖИВАНИЯ</div>
                                </div>
                                <div class="d-flex justify-content-between rating_buttons w-100">
                                    <div class="green_btn" @click="saveRating(1)">
                                        <div class="rating">
                                            <i class="far fa-thumbs-up"></i>
                                        </div>
                                    </div>
                                    <div class="red_btn" @click="saveRating(0)">
                                        <div class="rating">
                                            <i class="far fa-thumbs-down"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--THANK YOU-->
            <div v-if="this.page === 3" key="thank_page">
                <div class="tabletBody message_line">
                    <div class="container">
                        <div class="row">
                            <div class="align-items-center d-flex flex-wrap h-100 justify-content-between position-absolute text-center thank_you">
                                <div class="d-flex flex-column kaz w-100">
                                    <span class="thnx">Рахмет!</span>
                                    <span class="desc">Сіздің рейтингіңіз қабылданды</span>
                                </div>
                                <div class="d-flex flex-column rus w-100">
                                    <span class="thnx">Спасибо!</span>
                                    <span class="desc">Ваша оценка принята</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--PAUSE PAGE-->
            <div v-if="this.page === 4" key="pause_page">
                <div class="tabletBody message_line">
                    <div class="container">
                        <div class="row">
                            <div class="align-items-center d-flex flex-wrap h-100 justify-content-between position-absolute text-center thank_you">
                                <div class="d-flex flex-column kaz w-100">
                                    <span class="thnx" style="font-size: 50px">Өтінемін, 15 минут күтіңіз</span>
                                    <span class="desc" style="font-size: 48px">Маман клиентке қызмет көрсетеді</span>
                                </div>
                                <div class="d-flex flex-column rus w-100">
                                    <span class="thnx" style="font-size: 50px">Пожалуйста, подождите 15 минут</span>
                                    <span class="desc" style="font-size: 48px">Специалист обслуживает клиента</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </transition>
    </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {
                worker_place: window.location.pathname.replace('/t-', '/table-'),
                active_status: '',
                computer_name: '',
                id: '',
                login: '',
                tablet_number: '',
                task_number: '',
                updated_at: '',
                user_name: '',
                user_surname: '',
                user_photo: '',
                tablet_data: [],
                worker_photo: '',
                page: 0,
                rating: 0
            }
        },
        created() {
            this.interval = setInterval(this.getUserStatus, 3000);
        },
        methods: {
            getUserStatus() {
                axios.get(this.worker_place).then(response => {
                    this.tablet_data = response.data
                    this.user_surname = this.tablet_data.user_name.split(' ')[0]
                    this.user_name = this.tablet_data.user_name.split(' ')[1]
                    this.user_photo = '/workers/' + this.tablet_data.worker_photo
                    this.active_status = this.tablet_data.active_status
                    this.computer_name = this.tablet_data.computer_name
                    this.login = this.tablet_data.login
                    this.tablet_number = this.tablet_data.tablet_number
                    this.task_number = this.tablet_data.task_number

                    if (this.login === 1) {
                        this.page = 1
                        if (this.active_status === 'on') {
                            this.page = 1
                            if (this.task_number > 0) {
                                this.page = 2
                                clearInterval(this.interval);
                                this.pause_for_rating = setTimeout(() => {
                                    this.setUserPage()
                                }, 30000)
                            }
                        } else {
                            this.page = 4
                        }
                    } else {
                        this.page = 0
                    }
                })
            },

            setUserPage() {
                axios.post('/api/1c', {
                    "computer_name": this.computer_name,
                    "user_name": this.user_surname + ' ' + this.user_name,
                    "login": 1,
                    "task_number": 0
                }).then(function (response) {
                }).catch(function (error) {
                    console.log(error);
                })
                this.interval = setInterval(this.getUserStatus, 3000)
            },

            saveRating(send_rating) {
                var rating = {
                    'worker': this.user_surname + ' ' + this.user_name,
                    'task_number': this.task_number,
                    'rating': send_rating,
                    'tablet_number': this.tablet_number,
                    'headers': {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }
                this.page = 3
                axios.post('/postrating', rating).then((response) => {
                    clearTimeout(this.pause_for_rating)
                    setTimeout(()=>{
                        this.setUserPage()
                    }, 2000)
                })
            }
        }
    }
</script>
<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s ease-in-out;
    }
</style>